module.exports = __webpack_public_path__ + "img/user_avatar_offline.5d9d8009.png";